export const getTimezoneName = (
  timeZone: string,
  timeZoneName: "short" | "long" | "shortOffset" | "longOffset" | "shortGeneric" | "longGeneric",
  language: string
): string =>
  Intl.DateTimeFormat(language || "en-US", {
    hour: "numeric",
    timeZone,
    timeZoneName,
  })
    .format(new Date())
    .split(/\s/g)
    .slice(2)
    .join(" ");
